/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCropLandscape = createReactComponent("outline", "crop-landscape", "IconCropLandscape", [["path", { "d": "M4 6m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

export { IconCropLandscape as default };
//# sourceMappingURL=IconCropLandscape.mjs.map
